module.exports = __webpack_public_path__ + "static/img/291_TO8_2469_og.da92231.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/291_TO8_2469_og.jpg
// module id = HIl5
// module chunks = 0